import { LegacyReferralAreaEnum, LegacyReferralAreaOptions, LegacyReferralStatusOptions } from '@generated';
import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { DatePickerField } from '~/shared/forms/controls/base-fields/DatePickerField';
import { SelectField } from '~/shared/forms/controls/base-fields/SelectField';
import { parseISO } from '~/util/date';
import type { SieveFilterModel } from '~/util/sieve/filter';

export function CreatedSinceFilter() {
	const [createdSince, setCreatedSince] = useQueryDataTableFilter({
		name: 'dateCreated',
		convertFromQueryParam: value => parseISO(value),
		convertToQueryParam: value => value.toISOString(),
		operator: '>='
	});
	return <DatePickerField label="Created Since" hideLabel required value={createdSince} onChange={setCreatedSince} />;
}

export function ReferralStatusFilter() {
	const [statusId, setStatusId] = useQueryDataTableFilter<number>({
		name: 'statusId',
		convertFromQueryParam: value => Number(value)
	});
	return (
		<SelectField
			label="Status"
			hideLabel
			placeholder="All Statuses"
			value={statusId}
			onChange={id => setStatusId(id ? Number(id) : null)}
			items={[{ id: 0, label: 'All' }, ...LegacyReferralStatusOptions]}
		/>
	);
}

export function AreaFilter() {
	const [areaId, setAreaId] = useQueryDataTableFilter<number>({
		name: 'areaId',
		convertFromQueryParam: value => Number(value)
	});
	return (
		<SelectField
			label="Area"
			hideLabel
			placeholder="All Areas"
			value={areaId}
			onChange={id => setAreaId(id && Number(id) !== LegacyReferralAreaEnum.All ? Number(id) : null)}
			items={LegacyReferralAreaOptions}
		/>
	);
}

export const referralViews = [
	{ id: 'my-unstaffed', name: 'My Unstaffed Referrals' },
	{ id: 'all-unstaffed', name: 'All Unstaffed Referrals' },
	{ id: 'mine', name: 'My Referrals' },
	{ id: 'all', name: 'All Referrals' }
];

export function getReferralViewFilters(view: string, userId: string): SieveFilterModel[] {
	const unstaffed: SieveFilterModel = { name: 'fullyStaffed', operator: '==', value: false };
	const mine: SieveFilterModel = { name: 'createdById', operator: '==', value: userId };
	switch (view) {
		case 'all-unstaffed':
			return [unstaffed];
		case 'mine':
			return [mine];
		case 'all':
			return [];
		default:
			return [unstaffed, mine];
	}
}

export const refreshIntervals = [
	{ id: 0, label: 'No Refresh' },
	{ id: 5 * 60 * 1000, label: 'Every 5 Minutes' },
	{ id: 10 * 60 * 1000, label: 'Every 10 Minutes' }
];
